// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__feOlC","left":"styles_left__3xkSa","desktopActions":"styles_desktopActions__B01-X","title":"styles_title__2OfWQ"};